import { render, staticRenderFns } from "./Controller.vue?vue&type=template&id=1ea600d2&lang=pug"
import script from "./Controller.vue?vue&type=script&lang=js"
export * from "./Controller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports